import { z } from 'zod'

import { occasionType } from './product.js'

/**
 * 운영자 홈 대시보드 계약 (BIZ-14, 기획서 9.1).
 *
 * 운영자가 "지금 처리할 일"을 카드로 본다. 각 카드는 총 건수 + 상위 몇 건의 요약.
 * 운영자 전용이라 기업명·주문번호가 채워진다(공급가·판매가 같은 금액은 담지 않는다).
 */

export const dashboardCardItem = z.object({
  id: z.number().int(),
  orderNo: z.string().nullable(),
  companyName: z.string().nullable(),
  occasionType,
  desiredDate: z.string().nullable(),
  status: z.string(),
})
export type DashboardCardItem = z.infer<typeof dashboardCardItem>

/** 한 카드: 전체 건수 + 상위 항목(목록은 상한이 있어 count와 다를 수 있다). */
export const dashboardCard = z.object({
  count: z.number().int(),
  items: z.array(dashboardCardItem),
})
export type DashboardCard = z.infer<typeof dashboardCard>

export const dashboardResponse = z.object({
  /** 접수됨, 아직 검수 전 (SUBMITTED). */
  newOrders: dashboardCard,
  /** 발주 대기: 검수/배정 단계 + 희망일 임박(D-3). 예약 발주 누락 방지. */
  awaitingPo: dashboardCard,
  /** 오늘 배송 예정. */
  deliveringToday: dashboardCard,
  /** 내일 배송 예정. */
  deliveringTomorrow: dashboardCard,
  /** 발주했으나 업체가 아직 접수 안 함 (PO_SENT). */
  vendorPending: dashboardCard,
  /** 업체가 발주를 거절함 (VENDOR_REJECTED) — 다른 업체로 재배정 필요. */
  vendorRejected: dashboardCard,
  /** 배송 문제 발생 (DELIVERY_ISSUE). */
  deliveryIssue: dashboardCard,
  /** 배송 완료됐으나 사진·예외 사유 둘 다 없음. */
  photoMissing: dashboardCard,
})
export type DashboardResponse = z.infer<typeof dashboardResponse>
